<template>
  <el-dialog
    width="800px"
    v-if="visible"
    :title="$t('invite_14')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form :model="initData" ref="initData" :rules="ruleInitData" size="small" label-width="180px" class="item-form">
      <!-- 提醒名称-->
      <el-form-item :label="$t('invite_27')" prop="name">
        <el-input
          class="input"
          v-model="initData.name"
          maxlength="50"
          show-word-limit
          :placeholder="$t('please_enter_message')"
        ></el-input>
      </el-form-item>
      <!-- 提醒时间-->
      <el-form-item :label="$t('invite_23')" required>
        <template slot="label">
          <span>{{ $t('invite_23') }}</span>
          <el-tooltip class="item" effect="dark" :content="$t('invite_26')" placement="top-start">
            <img class="icon" src="@/assets/img/icon_tip.png" alt="" />
          </el-tooltip>
        </template>
        <div class="remind-data" v-for="(item, index) in initData.notice_time" :key="index">
          <el-form-item
            class="notice_time"
            :key="index + 'column'"
            :prop="`notice_time.${index}.column`"
            :rules="[{ required: true, message: $t('221'), trigger: 'change' }]"
          >
            <el-select
              v-model="item.column"
              :placeholder="$t('221')"
              @change="handleChangeColumn(item)"
              style="width: 200px"
            >
              <el-option v-for="(notice_date, key) in item.notice_date" :key="key" :label="notice_date" :value="key" />
            </el-select>
          </el-form-item>
          <el-form-item
            class="notice_time"
            :prop="`notice_time.${index}.type`"
            :rules="[{ required: true, message: $t('221'), trigger: 'change' }]"
          >
            <el-select class="node" v-model="item.type" :placeholder="$t('221')" style="width: 100px">
              <el-option
                v-for="(notice_date_type, key) in item.notice_date_type"
                :key="notice_date_type"
                :label="$t(notice_date_type)"
                :disabled="item.column === 'hire_date' && key === '1'"
                :value="key"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            class="notice_time"
            :prop="`notice_time.${index}.day`"
            :rules="[{ required: true, message: $t('1256'), trigger: 'blur' }]"
          >
            <el-input
              v-model.number="item.day"
              @input="item.day = String(item.day).replace(/[^\d]/g, '')"
              :placeholder="$t('90')"
              style="width: 100px"
            />
          </el-form-item>
          <span>{{ $t('1522') }}</span>
          <i v-if="index === 0" @click="addRemindData" class="el-icon-circle-plus-outline add"></i>
          <i
            v-if="initData.notice_time.length > 1"
            @click="delRemindData(index)"
            class="el-icon-remove-outline add"
          ></i>
        </div>
      </el-form-item>
      <!-- 适用试用期状态 -->
      <el-form-item :label="$t('invite_33')" prop="formal_state">
        <el-checkbox-group v-model="initData.formal_state">
          <el-checkbox v-for="(item, key) in regularInfo.staff_formal_state" :key="item" :value="key" :label="key">
            {{ item }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <!-- 通知对象 -->
      <el-form-item :label="$t('invite_24')" prop="notice_to">
        <el-checkbox-group v-model="initData.notice_to">
          <el-checkbox v-for="(item, key) in regularInfo.send_to" :key="item" :value="key" :label="key">
            {{ item }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <!-- 请选择指定通知人 -->
      <el-form-item v-if="initData.notice_to.includes('3')" :label="$t('invite_36')" prop="staff_ids">
        <div class="staff-list input" @click="openOrg">
          <template v-if="initData.staff_ids && initData.staff_ids.length">
            <el-tag
              type="info"
              size="mini"
              closable
              v-for="(tag, index) in initData.staff_ids"
              :key="tag.staff_id"
              @close="closeStaff(index, item)"
            >
              {{ tag.staff_name }}
            </el-tag>
            <p>{{ $t('1653', { x: initData.staff_ids.length }) }}</p>
          </template>
          <span class="staff-tip" v-else>{{ $t('221') }}</span>
        </div>
        <organization
          v-if="orgVisible"
          ref="organization"
          :visible.sync="orgVisible"
          :defaultDepatment="[]"
          :defaultEmployess="initData.staff_ids"
          :showType="1"
          :staffMax="staffMax"
          :show="{ showType: '1' }"
          @onConfirm="getSelectNode"
        >
        </organization>
      </el-form-item>
      <!-- 通知方式 -->
      <el-form-item :label="$t('invite_25')" prop="send">
        <el-checkbox-group v-model="initData.send">
          <el-checkbox v-for="(item, key) in regularInfo.notice_type" :key="item" :value="key" :label="key">
            {{ item }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <!-- 标题-->
      <el-form-item :label="$t('204')" prop="title">
        <el-input
          class="input"
          v-model="initData.title"
          maxlength="50"
          show-word-limit
          :placeholder="$t('please_enter_message')"
        ></el-input>
      </el-form-item>
      <!-- 内容模板-->
      <el-form-item :label="$t('invite_38')" prop="content">
        <div class="content">
          {{ $t('invite_39') }}
          <el-tooltip class="item" effect="dark" :content="$t('invite_40')" placement="top-start">
            <img class="icon" src="@/assets/img/icon_tip.png" alt="" />
          </el-tooltip>
          <span v-for="(item, index) in contentTemplate" :key="index">
            <span>{{ item.key }} </span>
            <el-tag @click="handleContent(index + 1, item.value)">#{{ item.value }}#</el-tag>
          </span>
        </div>
        <el-input
          type="textarea"
          :placeholder="$t('please_enter_message')"
          v-model="initData.content"
          maxlength="1000"
          class="textarea"
          :rows="6"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="dataFormSubmit">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getRegularInfo } from '@/api/org/per'
import { saveNoticeConfig } from 'api/dashboard'
import organization from '@/components/organization'
import { contentTemplate, initData, ruleInitData } from './config.js'
export default {
  components: { organization },
  data() {
    return {
      visible: false,
      contentTemplate,
      initData: JSON.parse(JSON.stringify(initData)),
      ruleInitData,
      regularInfo: {},
      staffMax: 100,
      orgVisible: false
    }
  },
  methods: {
    init(row) {
      this.visible = true
      this.regularInfoFn() // 试用期管理枚举项
      if (row) this.initData = JSON.parse(JSON.stringify(row))
      this.$nextTick(() => {})
    },
    async regularInfoFn() {
      const res = await getRegularInfo() // 试用期管理枚举项
      if (res && res.code === 1) this.regularInfo = res.data
      this.initData.notice_time.forEach(item => {
        this.$set(item, 'notice_date', this.regularInfo.notice_date)
        this.$set(item, 'notice_date_type', this.regularInfo.notice_date_type)
      })
    },
    handleClose() {
      this.visible = false
      this.initData = JSON.parse(JSON.stringify(initData))
      this.$refs.initData.resetFields()
    },
    handleChangeColumn(item) {
      item.type = ''
    },
    delRemindData(index) {
      this.initData.notice_time.splice(index, 1)
    },
    addRemindData() {
      // 添加提醒时间
      if (this.initData.notice_time.length === 5) return
      this.initData.notice_time.push({
        column: '', // 提醒时间：转正日期、入职日期
        type: '', // 提醒时间：之前、之后
        day: '', // 提醒时间： XX天
        notice_date: this.regularInfo.notice_date,
        notice_date_type: this.regularInfo.notice_date_type
      })
    },
    openOrg() {
      // 打开选择人员弹窗
      this.orgVisible = true
    },
    getSelectNode(data) {
      // 选择人员
      this.initData.staff_ids = data.staff_list
    },
    closeStaff(index) {
      // 删除选择人员
      this.initData.staff_ids.splice(index, 1)
    },
    handleContent(type, name) {
      // 点击变量
      this.initData.content += `#${name}#，`
    },
    dataFormSubmit() {
      this.$refs.initData.validate(valid => {
        if (valid) {
          this.initData.staff_ids = this.initData.staff_ids.map(item => item.staff_id)
          saveNoticeConfig(this.initData).then(res => {
            if (res && res.code === 1) {
              this.$emit('noticeConfig')
              this.$message.success(res.message)
              this.handleClose()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.remind-data {
  display: flex;
  margin-bottom: 20px;
  .notice_time {
    margin-right: 10px;
  }
  .el-select {
    width: 180px;
  }
  span {
    margin-left: 5px;
  }
  .add {
    margin-left: 10px;
    font-size: 20px;
    line-height: 32px;
    cursor: pointer;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -4px;
  margin-left: 5px;
}
.staff-list {
  cursor: pointer;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 0px 120px 0px 15px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;
  p {
    position: absolute;
    right: 15px;
    top: 0;
  }
  .el-tag {
    margin: 6px 5px 6px;
  }
  .staff-tip {
    color: #bfbfbf;
  }
}
.staff {
  /deep/ .el-input__inner {
    cursor: pointer;
  }
}
.input {
  min-width: 100%;
  /deep/ .el-input__inner {
    padding-right: 60px;
  }
}
.content {
  margin-bottom: 10px;
  word-break: break-word;
  .item {
    margin-right: 20px;
  }
  .el-tag {
    margin-right: 10px;
    cursor: pointer;
  }
}
.textarea {
  /deep/ .el-textarea__inner {
    padding-right: 65px;
  }
}
</style>
